import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Domain } from '@feathr/blackbox';
import { domainStatusToColorMap, domainStatusToLabelMap } from '@feathr/blackbox';
import { Pill } from '@feathr/components';

interface IProps {
  domain: Domain;
}

function ContentStatusPill({ domain }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const status = domain.contentDomainStatus;

  return (
    <Pill
      isLoading={domain.isPending}
      theme={domainStatusToColorMap[status]}
      tooltip={
        domain.isContentServingReady
          ? t('This domain can be used to serve pages, invite pages, and partner dashboards.')
          : t('Add CNAME records for this domain to your DNS host to use it for serving content.')
      }
    >
      {domainStatusToLabelMap[status]}
    </Pill>
  );
}

export default observer(ContentStatusPill);
